<template>
    <div class="relative">
        <button
            @click="open = !open"
            class="p-2 rounded-full hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors flex justify-center items-center active:bg-slate-200 focus:outline-slate-200 focus:border-slate-200 hover:border-slate-300 active:border-slate-300"
            aria-haspopup="true"
            :aria-expanded="open"
        >
            <Icon icon="dots-vertical" class="text-slate-600 dark:text-slate-400" />
        </button>
        <Transition name="fade">
            <div
                v-if="open"
                class="z-50 absolute right-0 top-full mt-1 w-52 bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-slate-200 dark:border-slate-700 flex flex-col p-2"
                v-click-outside="() => (open = false)"
            >
                <button
                    class="rounded flex items-center gap-2 px-3 py-2 text-sm text-slate-800 dark:text-slate-100 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors w-full text-left active:bg-slate-200 focus:outline-slate-200 focus:border-slate-200 hover:border-slate-300 active:border-slate-300"
                    @click="emitAndClose('edit-nickname')"
                >
                    <Icon icon="edit-2" class="w-4 h-4" />
                    Edit nickname
                </button>
                <button
                    class="rounded flex items-center gap-2 px-3 py-2 text-sm text-slate-800 dark:text-slate-100 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors w-full text-left active:bg-slate-200 focus:outline-slate-200 focus:border-slate-200 hover:border-slate-300 active:border-slate-300"
                    @click="emitAndClose('delete')"
                >
                    <Icon icon="trash" class="w-4 h-4" />
                    Remove connection
                </button>
            </div>
        </Transition>
    </div>
</template>

<script>
import { ref } from 'vue';
import Icon from '@/components/ui/icon/icon.vue';
import vClickOutside from 'click-outside-vue3';

export default {
    name: 'ConnectionDropdown',
    components: {
        Icon,
    },
    directives: {
        'click-outside': vClickOutside.directive,
    },
    emits: ['edit-nickname', 'delete'],
    setup(props, { emit }) {
        const open = ref(false);

        function emitAndClose(eventName) {
            emit(eventName);
            open.value = false;
        }

        return {
            open,
            emitAndClose,
        };
    },
};
</script>
